import { createFileRoute, notFound } from "@tanstack/react-router";

import { loadNamespaces } from "../../../app/i18n";
import { DevCheckoutPage } from "../../../areas/public/pay/DevCheckoutPage";

/**
 * Mock gateway page (FE-13 FR-FE13-14), local and staging builds only. `VITE_ENV` is replaced at
 * build time, so in a production build the page is never referenced: Rollup drops the module from
 * the (lazily split) route chunk and the route answers the 404 page (FE-01 FR-FE01-31).
 */
const IS_PRODUCTION = import.meta.env.VITE_ENV === "production";

export const Route = createFileRoute("/dev/checkout/$id")({
  beforeLoad: async () => {
    if (IS_PRODUCTION) throw notFound();
    await loadNamespaces("pay");
  },
  component: DevCheckoutRoute,
});

function DevCheckoutRoute() {
  const { id } = Route.useParams();
  return IS_PRODUCTION ? null : <DevCheckoutPage id={id} />;
}
